
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class comorbiditiesTableOverview extends Vue {

  headerTranslations: Record<string, string> = {
    comorbodity: "Komorbiditäten",
    comorbodityCount: "Anzahl, gesamt",
    executedYes: "GH/ IGF-1 kontrolliert",
    executedNo: "GH/ IGF-1 nicht kontrolliert",
    executedNoInfo: "GH/ IGF-1 keine Angabe",
    procedureNoInfo: "GH/ IGF-1 keine Aussage möglich"

  };

  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("comorbiditiesTableOverview");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("comorbiditiesTableOverview");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
